import { render } from "./AppServices.vue?vue&type=template&id=270cd11b&scoped=true"
import script from "./AppServices.vue?vue&type=script&lang=js"
export * from "./AppServices.vue?vue&type=script&lang=js"

import "./AppServices.vue?vue&type=style&index=0&id=270cd11b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270cd11b"]])

export default __exports__